import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { BundleProgressBar } from './BundleProgressBar';
import { LookProgressBar } from './LookProgressBar';
import { BYOTabs } from './BYOTabs';
import styles from './BundleLookStickyHeader.module.scss';
import './BundleLookStickyHeader.global.scss';

const BundleLookStickyHeader = ({ className, hasTabs, isBundle }) => {
  useEffect(() => {
    window.theme.byoStickBar();
  }, []);

  return (
    <section className={classnames(styles.root, className, 'js-byo-header')}>
      <div className="container">
        {isBundle ? <BundleProgressBar /> : <LookProgressBar />}
        {hasTabs && <BYOTabs />}
      </div>
    </section>
  );
};

BundleLookStickyHeader.propTypes = {
  isBundle: PropTypes.bool,
  hasTabs: PropTypes.bool,
  className: PropTypes.string
};

BundleLookStickyHeader.defaultProps = {
  isBundle: false,
  hasTabs: false,
  className: null
};

export { BundleLookStickyHeader };
